import { LayoutConst } from "core";
import { BTag } from "core/components";
import { MoreButton } from "shared/components/more-button";
import styled, { css } from "styled-components";

export const FolderContainer = styled.div`
    position: relative;
    display: flex;
    place-items: center;
    min-width: 0;
    flex-shrink: 1;

    .moreIcon {
        transform: rotate(90deg);
        margin-bottom: 10px;
    }

    div{
      display: inline;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
`;

export const FolderTagContainer = styled.div`
  position: relative;
  max-height: 30px;
  min-height: 30px;
  * {
    margin-bottom: 0 !important;
    max-height: 30px;
    min-height: 30px;

    @media (max-width: ${LayoutConst.screen.m}px) {
    max-height: 26px;
    min-height: 26px;
    }
  }

  svg {
    path {
      fill: ${({ theme }) => theme.app.text};
    }
  }
`;

export const FolderItem = styled(BTag)<{ isActive?: boolean }>`
    white-space: nowrap;
    display: flex
    flex-flow: row;
    max-height: 32px;
    min-height: 32px;
    width: fit-content;
    margin-bottom: 0 !important;
    margin-right: 0 !important;

    * {
      margin-bottom: 0 !important;
      margin-right: 0 !important;
    }
`;import { LayoutConst } from "core";
import { BTag } from "core/components";
import { MoreButton } from "shared/components/more-button";
import styled, { css } from "styled-components";

export const FolderContainer = styled.div`
    position: relative;
    display: flex;
    place-items: center;
    min-width: 0;
    flex-shrink: 1;

    .moreIcon {
        transform: rotate(90deg);
        margin-bottom: 10px;
    }

    div{
      display: inline;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
`;

export const FolderTagContainer = styled.div`
  position: relative;
  max-height: 30px;
  min-height: 30px;
  * {
    margin-bottom: 0 !important;
    max-height: 30px;
    min-height: 30px;

    @media (max-width: ${LayoutConst.screen.m}px) {
    max-height: 26px;
    min-height: 26px;
    }
  }

  svg {
    path {
      fill: ${({ theme }) => theme.app.text};
    }
  }
`;

export const FolderItem = styled(BTag)<{ isActive?: boolean }>`
    white-space: nowrap;
    display: flex
    flex-flow: row;
    max-height: 32px;
    min-height: 32px;
    width: fit-content;
    margin-bottom: 0 !important;
    margin-right: 0 !important;

    * {
      margin-bottom: 0 !important;
      margin-right: 0 !important;
    }
`;